// import formatTime from '@/utils/common.js';
export const tableConfig = {
    searchList: {
        searchLeftSpan: 4,
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNo',
                span: 24,
                name: '条码字符串',
                clearable: true
            }
        ]
    },
    table: {
        showOtpColumnConfig: true,
        rowKey: 'id',
        height: 'calc( 100vh - 220px )', // 样式被穿透了
        columns: [
            {
                label: '来源系统',
                align: 'center',
                prop: 'sourceSys',
                width: 190
            },
            {
                label: '箱码',
                align: 'center',
                prop: 'cartonBarcodeNo',
                width: 130
            },
            {
                label: '托盘码',
                align: 'center',
                prop: 'palletBarcodeNo',
                width: 130
            },
            {
                label: '条码',
                align: 'center',
                prop: 'barcodeNo',
                width: 180
            },
            {
                label: '商品编码',
                align: 'center',
                prop: 'itemCode',
                width: 120
            },
            {
                label: '商品名称',
                align: 'center',
                prop: 'itemName',
                width: 130
            },
            {
                label: '数量',
                align: 'center',
                prop: 'quantity',
                width: 140
            },
            {
                label: '生产日期',
                align: 'center',
                prop: 'prodDate',
                width: 140
            },
            {
                label: '更新日期',
                align: 'center',
                prop: 'billDate',
                width: 100
            },
            {
                label: '单位类型',
                align: 'center',
                prop: 'orgType',
                width: 90
            },
            {
                label: '当前节点单位编码',
                align: 'center',
                prop: 'orgCode',
                width: 150
            },
            {
                label: '当前节点单位名称',
                align: 'center',
                prop: 'orgName',
                width: 150
            },
            {
                label: '工厂名称',
                align: 'center',
                prop: 'mesName',
                width: 90
            },
            {
                label: '当前仓库',
                align: 'center',
                prop: 'whName',
                width: 90
            },
            {
                label: '收货客户',
                align: 'center',
                prop: 'customerName',
                width: 90
            },
            {
                label: '承运商名称',
                align: 'center',
                prop: 'carrierName',
                width: 90
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
